
import { Component, MixedVue, mixins } from "@/vue";
import { StripeElementPayment } from "@vue-stripe/vue-stripe";
import ContentTransition from "../ContentTransition.vue";
import Loading from "../Loading.vue";
import { propsInstance } from "@/lib/util";
import { UserLicense } from "@/lib/types/User";

const Props = propsInstance<{
  license?: UserLicense;
}>({
  license: { type: Object },
});
@Component({
  name: "CardPayment",
  components: {
    StripeElementPayment,
    Loading,
  },
})
export default class CardPayment extends mixins(MixedVue, Props) {
  static components: {
    StripeElementPayment: typeof StripeElementPayment;
    Loading: typeof Loading;
  };

  $refs: {
    paymentRef: StripeElementPayment;
  };

  isLoading = true;
  isLoadingSubmit = false;
  /* debounced to avoid flickering */
  showLoadingIndicator = false;
  timeoutId: NodeJS.Timeout | null = null;

  get clientSecret() {
    return this.license?.card_payment?.client_secret;
  }

  get stripeKey() {
    return process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY;
  }

  get elementsOptions() {
    return {
      appearance: {
        theme: "stripe",
        variables: {
          fontFamily: '"InstrumentSans", sans-serif',
        },
      },
      clientSecret: this.clientSecret,
    };
  }

  get confirmParams() {
    return {
      return_url: `${window.location.origin}/redirect`,
    };
  }

  get locale() {
    return this.$language.current;
  }

  submit() {
    // @ts-ignore
    this.$refs.paymentRef.submit();
    this.computeSize();
  }

  computeSize() {
    setTimeout(() => {
      (this.$parent as ContentTransition).computeSize?.();
    }, 300);
  }

  handleLoading(isLoading: boolean) {
    this.isLoadingSubmit = isLoading;
    if (!isLoading) {
      this.showLoadingIndicator = false;
      clearTimeout(this.timeoutId);
    } else {
      this.timeoutId = setTimeout(() => {
        this.showLoadingIndicator = true;
      }, 300);
    }
  }

  poPayment() {
    this.$emit("po-payment");
  }
}
